import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import Collapsible from '../../Collapsible';
// eslint-disable-next-line css-modules/no-unused-class
import s from './Controlling.scss';
import { DATEONLY_STRING_FMT_DB } from '../../../core/dateonly';
import EmployeeBalance from '../../EmployeeBalance';
import List from '../../HoursList/List';
import RatioPanel from './RatioPanel';
import hoursEntryTypes from '../../../core/hoursEntryTypes';

class RatioPanelCards extends React.Component {
  static propTypes = {
    totalData: PropTypes.shape({
      billableHours: PropTypes.number.isRequired,
      nonBillableHours: PropTypes.number.isRequired,
    }).isRequired,
    initialOpen: PropTypes.bool,
    projectData: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        hours: PropTypes.number,
        billable: PropTypes.bool,
      }),
    ).isRequired,
    title: PropTypes.string,
    shortWorkSettings: PropTypes.shape({
      maxWeeklyHours: PropTypes.number.isRequired,
      minWeeklyHours: PropTypes.number.isRequired,
      start: PropTypes.string.isRequired,
      end: PropTypes.string.isRequired,
    }),
    user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
  };
  static defaultProps = {
    title: '',
    shortWorkSettings: null,
    initialOpen: false,
  };

  // eslint-disable-next-line class-methods-use-this
  getCardClassName(hoursPerWeek, settings) {
    if (!settings) return s.card;
    if (hoursPerWeek < settings.minWeeklyHours) {
      return `${s.card} ${s.underMinimum}`;
    }
    if (hoursPerWeek > settings.maxWeeklyHours) {
      return `${s.card} ${s.overMaximum}`;
    }
    return s.card;
  }

  render() {
    const {
      totalData,
      projectData,
      title,
      shortWorkSettings,
      user,
    } = this.props;

    const totalHours = (
      totalData.billableHours + totalData.nonBillableHours
    ).toFixed(2);

    let hoursPerWeek = 0;
    if (shortWorkSettings) {
      const weeks = moment(shortWorkSettings.end, DATEONLY_STRING_FMT_DB).diff(
        moment(shortWorkSettings.start, DATEONLY_STRING_FMT_DB),
        'weeks',
        true,
      );
      hoursPerWeek = totalHours / weeks;
    }

    const getPersonIsSickOrOnVacation = hoursEntries => {
      const date = moment().format('YYYY-MM-DD');
      const todaysType = hoursEntries.filter(
        entry =>
          entry.date === date &&
          (entry.type !== hoursEntryTypes.WORK &&
            entry.type !== hoursEntryTypes.HOLIDAY),
      );
      return todaysType.length > 0 ? todaysType[0].type : false;
    };

    const isSickOrVacation = getPersonIsSickOrOnVacation(user.hoursEntries);

    return (
      <div className={s.usersContainer}>
        <Collapsible
          initialOpen={this.props.initialOpen}
          contentClassName={s.ratioContent}
          headerClassName={this.getCardClassName(
            hoursPerWeek,
            shortWorkSettings,
          )}
          headerContent={
            <h4>
              {title} ({totalHours}h / {user.monthlyBalance.total.toFixed(2)}h)
              {isSickOrVacation && ` - ${isSickOrVacation}`}
            </h4>
          }
        >
          <div className={s.cardsContainer}>
            <button
              className="btn btn-primary"
              onClick={e => {
                e.preventDefault();
                window.location.href = `/admin/users/${user.username}/edit`;
              }}
              style={{ marginBottom: '10px', width: 'fit-content' }}
              type="button"
            >
              View user details
            </button>
            <EmployeeBalance
              user={user}
              dailyBalance={false}
              weeklyBalance={false}
            />
            <List user={user} latestEntriesOnly withBalance={false} />
            <h3>Projects</h3>
            <RatioPanel
              title="Project Ratios"
              totalData={totalData}
              projectData={projectData}
              showWorkCategory
            />
          </div>
        </Collapsible>
      </div>
    );
  }
}

export default injectIntl(withStyles(s)(RatioPanelCards));
